/* eslint-disable no-template-curly-in-string */
const validateMessages = {
  required: "${label} is required",
  types: {
    email: "${label} is not a valid email",
    number: "${label} is not a valid number",
  },
  number: {
    range: "${label} must be between ${min} and ${max}",
  },
};

export default validateMessages;

export const Max100Validate = (value: number) => {
  if (value > 100) return Promise.reject(new Error("Max input size 100"));
  return Promise.resolve();
};
